import { computed } from 'vue'

import { useConfigStore } from '../stores/config'

type LazyLoadingProps = {
  listOrderPosition?: number,
  includeDepth?: number,
  dataSliderInitialSlide?: boolean
}

export function useLazyLoadingUtils (props: LazyLoadingProps) {
  const imageLazyLoading = computed(() => useConfigStore().rsConfig.imageLazyLoading)

  const getLoadingValue = computed(() => {
    const isBelowAboveTheFoldThreshold =
      (props.listOrderPosition ?? 0) >=
      (imageLazyLoading.value?.aboveTheFoldParagraphCount?.StructureTerm ?? Infinity)

    const isNonInitialSliderImage =
      (props.includeDepth ?? 0) > 0 && !props.dataSliderInitialSlide

    return isBelowAboveTheFoldThreshold || isNonInitialSliderImage ? 'lazy' : 'eager'
  })

  return { getLoadingValue }
}
